import { FundClosingDrawdownType } from '__generated__/graphql';

import DataTable from 'components/DataTable';

import SlideOver from 'primitives/SlideOver';

const FundDrawdown = ({
  showDrawdown,
  setShowDrawdown,
  fundClosingDrawdown,
}: {
  showDrawdown: boolean;
  setShowDrawdown: (show: boolean) => void;
  fundClosingDrawdown: FundClosingDrawdownType[];
}) => {
  return (
    <SlideOver
      open={showDrawdown}
      onClose={() => setShowDrawdown(false)}
      title="Drawdown Details"
      subTitle="View and manage the details of this drawdown"
    >
      <div>
        <DataTable
          data={fundClosingDrawdown}
          columns={[
            {
              label: 'Status',
              fieldName: 'status',
              type: 'STATUS',
            },
            {
              label: 'Amount',
              fieldName: 'amount',
              type: 'CURRENCY',
            },
            {
              label: 'Invested On',
              fieldName: 'createdAt',
              type: 'DATE',
            },
            {
              label: 'Transfer Date',
              fieldName: 'drawdownDate',
              type: 'DATE',
            },
          ]}
          emptyListTitle="No drawdowns yet"
          emptyListDescription="Drawdown records will appear here once available."
        />
      </div>
    </SlideOver>
  );
};

export default FundDrawdown;
